export default __webpack_public_path__ + "static/media/AG11.30a6e411.mp3";